export default "__VITE_ASSET__CJ$ENNo2__"